import { render, staticRenderFns } from "./MyPassWord.vue?vue&type=template&id=f2ce4108&scoped=true&"
import script from "./MyPassWord.vue?vue&type=script&lang=js&"
export * from "./MyPassWord.vue?vue&type=script&lang=js&"
import style0 from "./MyPassWord.vue?vue&type=style&index=0&id=f2ce4108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ce4108",
  null
  
)

export default component.exports